import TabToggle from 'components/commons/tab-toogle'
import { InlineError } from 'avo-ui'
import TextEditor from 'components/commons/text-editor'

export const ProductInfo = ({ sectionRef, productDetail, onChangeForm, errorForm }) => {
    return (
        <div ref={sectionRef?.product_info}>
            <TabToggle
                title={'Product Info'}
                content={
                    <div className={'grid grid-cols-2 gap-y-5 gap-x-16 pb-11'}>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Deskripsi</div>
                            <div className={`flex-1 ${errorForm?.description ? 'space-y-12' : 'pb-10'}`}>
                                <TextEditor
                                    defaultValue={productDetail?.description || '<p></p>'}
                                    onChange={(value) => onChangeForm({ description: value })}
                                    placeholder={'Isi uraian deskripsi'}
                                />
                                <InlineError message={errorForm?.description} />
                            </div>
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Cara Penggunaan</div>
                            <div className={`flex-1 ${errorForm?.how_to_use ? 'space-y-12' : 'pb-10'}`}>
                                <TextEditor
                                    defaultValue={productDetail?.how_to_use || '<p></p>'}
                                    onChange={(value) => onChangeForm({ how_to_use: value })}
                                    placeholder={'Isi uraian cara penggunaan'}
                                />
                                <InlineError message={errorForm?.how_to_use} />
                            </div>
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Ingredient</div>
                            <div className={`flex-1 ${errorForm?.ingredients ? 'space-y-12' : 'pb-10'}`}>
                                <TextEditor
                                    defaultValue={productDetail?.ingredients || '<p></p>'}
                                    onChange={(value) => onChangeForm({ ingredients: value })}
                                    placeholder={'Isi uraian ingredient'}
                                />
                                <InlineError message={errorForm?.ingredients} />
                            </div>
                        </div>
                    </div>
                }
            />
        </div>
    )
}
